<app-base-chart-popover [title]="title">
  <app-chart-elements-details [details]="details"></app-chart-elements-details>
</app-base-chart-popover>
